import React from "react";
import { Link, useNavigate } from "react-router-dom";

import Left from "../assets/images/left.png";
import logo from "../assets/images/logo.png";

function HeaderRight(props) {
  const navigate = useNavigate();

  return (
    <>
      <header>
        <div className="custom_container ">
          <div className="login_logo  mb_40">
            <button
              style={{
                backgroundColor: "white",
                marginRight: 20,
                borderWidth: 0,
              }}
              onClick={() => navigate(-1)}
            >
              <img src={Left} alt="" />{" "}
            </button>

            <img src={logo} alt="" />
          </div>
        </div>
      </header>
    </>
  );
}

export default HeaderRight;
